import Grid from '@mui/material/Grid';
import { errorMessage } from 'constants/CommonConstants';
import { atLeastOneFieldValidationRule } from 'helper';
import React, { useImperativeHandle } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { CommonInput } from 'sharedComponents/inputGroup';
import { Lead } from '../LeadGenInterface';
import { AnyAction, ThunkDispatch } from '@reduxjs/toolkit';
import { RootState } from 'store/store';
import { useDispatch, useSelector } from 'react-redux';
import { postLeadCreation } from 'store/LeadCreationState';
import { StepperFromProps } from 'sharedComponents/dynamicStepperForm/dynamicStepperFormInterface';

const YearsOfLived: React.ForwardRefRenderFunction<unknown, StepperFromProps> = (
  { onNext, onBack, isSubmit, mappedData },
  ref
) => {
  // Hooks
  const { t } = useTranslation();

  const hasCalledNextStep = React.useRef(false);

  // Redux
  const dispatch: ThunkDispatch<RootState, AnyAction, AnyAction> = useDispatch();

  const { authenticateClientData } = useSelector((state: RootState) => state.auth) || {};
  const widgetData = authenticateClientData?.data?.widgetData || {};

  // React Hook Form
  const { control, trigger, getValues } = useFormContext();

  // React Hook Form Trigger
  const nextStep = async () => {
    if (hasCalledNextStep.current) return;
    hasCalledNextStep.current = true;

    const { yearsLivedThere, monthsLivedThere } = getValues();

    const yearsOfLivedData: Lead = {
      leadSourceId: widgetData?.leadSourceId,
      isSubmit,
      leadDetails: {
        'Years Lived There': yearsLivedThere,
        'Months Lived There': monthsLivedThere,
        ...mappedData,
      },
    };

    dispatch(postLeadCreation({ data: yearsOfLivedData, leadTypeID: widgetData?.leadTypeId })).then((res) => {
      if (
        res?.payload?.success &&
        (res?.payload?.data?.draftLeadId || res?.payload?.data?._id || res?.payload?.data?.Lead?.leadId)
      ) {
        onNext?.();
      }
    });
  };

  const backStep = () => {
    onBack?.();
  };
  useImperativeHandle(ref, () => ({
    nextStep,
    backStep,
  }));

  return (
    <Grid container justifyContent={{ xs: 'center' }}>
      <Grid item xs={12} lg={9}>
        <h3 className='dy-stepper-form__body__title text-center'>{t('leadGen.yearOfLived')}</h3>
        <Grid container rowSpacing={3} columnSpacing={2}>
          <Grid item sm={6} xs={12}>
            <CommonInput
              name='yearsLivedThere'
              control={control}
              label={t('leadGen.years')}
              placeholder={t('leadGen.enterYear')}
              rules={{
                ...atLeastOneFieldValidationRule('monthsLivedThere', errorMessage(t).yearsRequired),
              }}
              triggerValidationForField={trigger}
              type='number'
            />
          </Grid>
          <Grid item sm={6} xs={12}>
            <CommonInput
              name='monthsLivedThere'
              control={control}
              label={t('leadGen.month')}
              placeholder={t('leadGen.enterMonth')}
              rules={{
                ...atLeastOneFieldValidationRule('yearsLivedThere', errorMessage(t).livedMonthsRequired),
              }}
              triggerValidationForField={trigger}
              type='number'
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

const YearsOfLivedStep = React.forwardRef(YearsOfLived);

export default YearsOfLivedStep;
